module.exports = __webpack_public_path__ + "img/aboutUs6.60d82f5.png";